import React from 'react';
import { Modal, Button, FormControl, Row, Col, Checkbox, Radio }
  from 'react-bootstrap';
import {
  formatUnlinkedString,
  calculateUnlinkedObject,
  formatQuantity,
  formatNumber,
  formatCurrency,
  BOLD_FONT,
  formatRange,
} from './BaseElement.jsx';
import DTNameDisplayWrapper from '@/component/dict/simple/deliveryterm/NameDisplayWrapper';
import PlaceNameDisplayWrapper from '@/component/dict/simple/port/NameDisplayWrapper';
import ProductInPackingDisplayWrapper from
  '@/component/dict/complex/product/ProductInPackingDisplayWrapper';
import Quantity from './Quantity.jsx';
import { connect } from 'react-redux';
import Link from '../linkdeal/Link.jsx';
import { List } from 'immutable';
import AlertPopover from '@/util/AlertPopover.jsx';
import { getColor, UrlWrappedCol } from '../../../../util/util';
import longshort from '@/../style/longshort.png';

class CompositeProductElement extends React.Component {
  constructor(props) {
    super(props);
    this.accessDeniedAlert = this.accessDeniedAlert.bind(this);
    this.createDisplayData = this.createDisplayData.bind(this);
    this.onAtomClick = this.onAtomClick.bind(this);
    this.hideAccessDeniedAlert = this.hideAccessDeniedAlert.bind(this);
    this.state = { data: <div /> };
    this.alertClicked = false;
  }
  componentWillMount() {
    if (this.props.elem) {
      this.setState({ data: this.createDisplayData(this.props) });
    }
  }

  componentWillReceiveProps(props) {
    if (props.elem !== this.props.elem
        || props.product !== this.props.product
        || props.selectedAtoms !== this.props.selectedAtoms
        || props.selectedLinks !== this.props.selectedLinks
        || (props.alerts
            && props.alerts[`prod_${props.dealIdx}_${props.idx}`] !== this.props.alerts
          ? this.props.alerts[`prod_${props.dealIdx}_${props.idx}`]
          : undefined)) {
      this.setState({ data: this.createDisplayData(props) });
    }
  }

  onAtomClick() {
    if (this.props.allowUrl) {
      return true;
    }
    this.setState({ data: this.createDisplayData(this.props, true) });
    return false;
  }

  hideAccessDeniedAlert() {
    this.setState({ data: this.createDisplayData(this.props) });
  }

  accessDeniedAlert(show) {
    return (
      <Modal bsSize="sm" show={show} onHide={this.hideAccessDeniedAlert}>
        <Modal.Body style={{ textAlign: 'center' }}>
          You have insufficient privileges for access
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.hideAccessDeniedAlert}>Ok</Button>
        </Modal.Footer>
      </Modal>);
  }

  createDisplayData(props, showAccessDeniedAlert = false) {
    const linkId = typeof props.linkIdx !== 'undefined' ? `_${props.linkIdx}` : '';
    const productId = `${props.dealIdx || 0}_${props.idx}${linkId}`;
    if (!props.elem) {
      return <div />;
    }
    const color = getColor(props.product, props.elem.get('productType'));
    const showLinks = props.mode != 'checkbox' && props.mode != 'quantity' && (!props.hideLinks);
    const elementToCalcUnlinked = props.originalData ? props.originalData : props.elem;
    const unlinkedObject = calculateUnlinkedObject(elementToCalcUnlinked,
      elementToCalcUnlinked.get(`${props.dealType}Link`));
    const unlinkedString = formatUnlinkedString(unlinkedObject);
    let checked;
    if (props.mode === 'checkbox' || props.mode === 'radio') {
      checked = props.selectedAtoms
        ? props.selectedAtoms.has(props.elem.get('id'))
        : false;
      if (checked && props.link) {
        checked = props.selectedLinks
          ? props.selectedLinks.has(props.link.get('id'))
          : false;
      }
    }
    let linkingMode = false;
    let elementSelectControl;
    if (props.mode === 'parentatom' || props.mode === 'checkbox' || props.mode === 'radio'
     || props.mode === 'quantity') {
      linkingMode = true;
    }
    if (props.mode === 'checkbox') {
      elementSelectControl = (<Col xs={1}>
        <AlertPopover
          placement={props.dealType == 'purchase' ? 'right' : 'left'}
          data={props.alerts ? props.alerts[`prod_${productId}`] : undefined}
          target={`prod_${productId}`}
        />
        <Checkbox
          onChange={() =>
            props.handleSelected(
              props.dealIdx,
              props.data.get('id'),
              props.elem,
              `prod_${productId}`,
              props.link)
          }
          checked={checked}
          inline
          id={`product_checkbox_${props.idx}_${props.dealIdx}`}
        />
      </Col>);
    } else if (props.mode === 'radio') {
      linkingMode = true;
      elementSelectControl = (<Col style={{ width: '40px' }}>
        <AlertPopover
          placement={props.dealType == 'purchase' ? 'right' : 'left'}
          data={props.alerts ? props.alerts[`prod_${productId}`] : undefined}
          target={`prod_${productId}`}
        />
        <Radio
          name="dealRadio" style={{ float: 'right' }}
          onChange={() =>
            props.handleSelected(
              props.dealIdx,
              props.data.get('id'),
              props.elem,
              `prod_${productId}`,
              props.link)
          }
          checked={checked}
          inline
          id={`product_radio_${props.idx}_${props.dealIdx}`}
        />
      </Col>);
    }
    let elemColXs = 12;
    if (props.mode === 'quantity') {
      elemColXs = 6;
    }
    if (elementSelectControl) {
      elemColXs--;
    }
    const saleLinks = props.elem.get('saleLink', new List()).filter(l => !l.get('dontShowAtPLTab'));
    const purchaseLinks = props.elem.get('purchaseLink', new List());
    return (<Col
      style={props.style || {}}
      xs={12} key={`product-${props.idx}`}
      id={`product_${productId}`}
    >
      <Row
        style={props.dealEditMode ?
          { minHeight: props.mode === 'quantity' ? 170 : 0, flexGrow: 1 } :
          { minHeight: props.mode === 'quantity' ? 170 : 0 }
        }
        className={`${props.isLast ? 'last-composite-product' : 'not-last-composite-product'} ${
          props.isFirst ? 'first-composite-product' : ''}`}
        id={`product_${productId}`}
      >
        {props.mode === 'quantity' && props.dealType == 'sale' ?
          <span>
            {this.renderQuantity(props, unlinkedObject)}
            <Col sm={1} />
          </span>
          : ''}
        {elementSelectControl}
        <Col
          xs={elemColXs} style={elementSelectControl ?
            { height: '100%', width: 'calc(100% - 50px)', float: 'right' }
            :
            { height: '100%' }}
          id={props.mode != 'parentatom' ? `prod_${productId}` : ''}

        >
          {this.accessDeniedAlert(showAccessDeniedAlert)}
          <Row style={{ display: 'flex', flexDirection: 'row' }}>
            {showLinks && props.dealType == 'sale' ?
              <Col
                id={`links_${productId}`}
                className="links-block links-block-sale"
                sm={8}
              >
                {saleLinks.size > 0 ? saleLinks.map((link, linkIdx) =>
                  <Link
                    transport={this.props.transport}
                    key={`link-${linkIdx}`}
                    id={`link-${linkIdx}`}
                    label="Link to composite product"
                    fromType="sale"
                    toType="purchase"
                    defaultValue={link}
                    idx={linkIdx}
                    productIdx={props.idx}
                    dealIdx={props.dealIdx}
                    viewMode
                    product={props.elem}
                    disabled={this.props.disabled}
                    isLast={props.elem.get('saleLink').size - 1 === linkIdx}
                  />,
                )
                  : ''}
              </Col> : ''}
            <Col
              className="product-background"
              xs={props.hideLinks || props.mode === 'quantity' ? 12 : 4}
              style={{
                backgroundColor: color,
                left: showLinks && props.dealType == 'sale' ? '66.7%' : '0',
              }}
            />
            <UrlWrappedCol
              id={`self_${productId}`}
              xs={props.hideLinks || props.mode === 'quantity' ? 12 : 4}
              className="composite-product-element"
              url={linkingMode ? undefined : props.url}
              onClick={this.onAtomClick}
            >
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  flexGrow: 1,
                  width: '100%',
                  cursor: props.mode === 'checkbox' || props.mode === 'radio'
                    ? 'pointer'
                    : 'inherit',
                }}
                onClick={() => {
                  if (props.mode === 'checkbox' || props.mode === 'radio') {
                    props.handleSelected(
                      props.dealIdx,
                      props.data.get('id'),
                      props.elem,
                      `prod_${productId}`,
                      props.link,
                    );
                  }
                }}
              >
                <span className={'host-deal-header'}>
                  {props.header ? props.header(props.elem.get('id'), props.link, checked) : ''}
                </span>
                <Row style={{ paddingTop: 5 }}>
                  <Col sm={4}>
                    <span className="text-primary" style={BOLD_FONT}>
                      Product
                    </span>
                  </Col>
                  {props.elem.get('productType') || props.elem.get('packing') ?
                    <Col sm={8} id={`product_${productId}_productType`}>
                      <ProductInPackingDisplayWrapper
                        productTypeId={props.elem.get('productType')}
                        packingId={props.elem.get('packing')}
                        noBorder
                      />
                    </Col> : ''}
                </Row>
                <Row>
                  <Col sm={4}>
                    <span className="text-primary" style={BOLD_FONT}>
                      Quantity
                    </span>
                  </Col>
                  <Col
                    sm={8} className="word-break"
                    id={`product_${productId}_quantity`}
                  >
                    <span> {formatQuantity(props.elem, true)}</span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <span className="text-primary" style={BOLD_FONT}>
                      Price
                    </span>
                  </Col>
                  <Col sm={8} id={`product_${productId}_price`}>
                    <span style={{ whiteSpace: 'normal', wordBreak: 'break-all' }}>
                      {props.elem.get('fixedPrice') !== false && props.elem.get('priceValue') ?
                        `${formatCurrency(props.elem.get('priceCurrency'))}
                      ${formatNumber(props.elem.get('priceValue'), '0,0.00')} `
                        : ''}
                      {props.elem.get('fixedPrice') === false && props.elem.get('priceFormula') ?
                        `${props.elem.get('priceFormula', '').substring(0, 140)} ` : ''}
                      <DTNameDisplayWrapper
                        id={props.elem.get('deliveryTerm')}
                      />
                    </span>
                  </Col>
                </Row>
                <Row>
                  <Col sm={4}>
                    <span className="text-primary" style={BOLD_FONT}>
                      Port
                    </span>
                  </Col>
                  {props.elem.get('ports') ?
                    <Col sm={8} id={`product_${productId}_port`}>
                      <span style={{ whiteSpace: 'normal' }}>
                        {props.elem.get('ports') ?
                          props.elem.get('ports').map((port, idxPort) =>
                            <div key={idxPort} style={{ display: 'inline' }}>
                              <PlaceNameDisplayWrapper
                                id={port}
                                noBorder
                              />{' '}
                            </div>)
                          : ''}
                      </span>
                    </Col> : ''}
                </Row>
                <Row>
                  <Col sm={4}>
                    <span className="text-primary" style={BOLD_FONT}>
                      Shipment
                    </span>
                  </Col>
                  <Col sm={8} id={`product_${productId}_shipment`}>
                    <span style={{ whiteSpace: 'normal' }}>
                      {props.elem.get('shipmentFrom') || props.elem.get('shipmentTo') ?
                        formatRange(props.elem.get('shipmentFrom'),
                          props.elem.get('shipmentTo'))
                        : ''}
                    </span>
                  </Col>
                </Row>
                <Row
                  className="word-break"
                  style={{ padding: '10px 0', flexGrow: 1 }}
                >
                  <Col sm={4} className={'unlinked-product-label'}>
                    <img src={longshort} className={'unlinked_arrow'} role="presentation" />
                    <span className={'unlinked_text'}>
                      {props.dealType == 'purchase' ? 'Long' : 'Short'}
                    </span>
                  </Col>
                  <Col sm={8} className={'unlinked-product-value'}>
                    <span
                      id={`product_${productId}_unlinked`}
                      style={{ ...BOLD_FONT, fontSize: 15 }}
                    >
                      {unlinkedString}
                    </span>
                  </Col>
                </Row>
                {props.footer ? props.footer(props.elem, props.link, checked) : ''}
              </div>
            </UrlWrappedCol>
            {showLinks && props.dealType == 'purchase' ?
              <Col
                id={`links_${productId}`}
                className="links-block links-block-purchase"
                sm={8}
                style={{ flexGrow: 1 }}
              >
                {purchaseLinks.size > 0 ? purchaseLinks.map((link, linkIdx) =>
                  <Link
                    transport={this.props.transport}
                    key={`link-${linkIdx}`}
                    id={`link-${linkIdx}`}
                    label="Link to composite product"
                    fromType="purchase"
                    toType="sale"
                    defaultValue={link}
                    dealIdx={props.dealIdx}
                    idx={linkIdx}
                    productIdx={props.idx}
                    viewMode
                    productColor={color}
                    product={props.elem}
                    disabled={this.props.disabled}
                    isLast={props.elem.get('purchaseLink').size - 1 === linkIdx}
                  />,
                )
                  : ''}
              </Col> : ''}
          </Row>
        </Col>
        {props.mode === 'quantity' && props.dealType == 'purchase' ?
          <span>
            <Col sm={1} />
            {this.renderQuantity(props, unlinkedObject)}
          </span>
          : ''}
      </Row>
    </Col>);
  }
  renderQuantity(props, unlinkedObject) {
    return (<Col sm={5} className={'product-link-quantity'}>
      <span>
        <form
          id={`edit_quantity_${props.data.get('id')}_${props.elem.get('id')}`}
        >
          <FormControl
            id={`${props.dealType}Product`}
            name={`${props.dealType}Product`}
            value={props.elem.get('id')}
            style={{ display: 'none' }}
            onChange={() => ({})}
          />
          <FormControl
            id={`${props.dealType}ProductType`}
            name={`${props.dealType}ProductType`}
            value={props.elem.get('productType') ?
              props.elem.get('productType') : undefined}
            style={{ display: 'none' }}
            onChange={() => ({})}
          />
          <FormControl
            id={`${props.dealType}Packing`}
            name={`${props.dealType}Packing`}
            value={props.elem.get('packing') ?
              props.elem.get('packing') : undefined}
            style={{ display: 'none' }}
            onChange={() => ({})}
          />
          <FormControl
            id={`${props.dealType}Id`}
            name={`${props.dealType}Id`}
            value={props.data.get('id') ? props.data.get('id') : ''}
            style={{ display: 'none' }}
            onChange={() => ({})}
          />
          <Quantity
            id={`${props.data.get('id')}_${
              props.elem.get('productType')}_${props.idx}`}
            data={new Map()}
            multiNodalQuantity={this.props.multiNodalQuantity}
            updateOnNewProps={false}
            isLinking
            unlinkedObject={unlinkedObject}
          />
        </form>
      </span>
    </Col>);
  }
  render() {
    return this.state.data;
  }
}


CompositeProductElement.propTypes = {
  elem: React.PropTypes.object,
  data: React.PropTypes.object,
  idx: React.PropTypes.number,
  handleSelected: React.PropTypes.func,
  mode: React.PropTypes.string,
  col: React.PropTypes.number,
  noStatus: React.PropTypes.bool,
  dealType: React.PropTypes.string.isRequired,
  hideLinks: React.PropTypes.bool,
  dealEditMode: React.PropTypes.bool,
  alerts: React.PropTypes.object,
  selectedAtoms: React.PropTypes.object,
  selectedLinks: React.PropTypes.object,
  product: React.PropTypes.object,
  dealIdx: React.PropTypes.number,
  linkIdx: React.PropTypes.number,
  disabled: React.PropTypes.bool,
  header: React.PropTypes.func,
  footer: React.PropTypes.func,
  originalData: React.PropTypes.object,
  allowUrl: React.PropTypes.bool,
  link: React.PropTypes.object,
  transport: React.PropTypes.object,
  multiNodalQuantity: React.PropTypes.number,
};

export default connect(
  (state, props) => {
    if (props.mode === 'checkbox' || props.mode == 'radio') {
      return {
        selectedAtoms: props.data ?
          state.getIn(['links', 'atoms', 'selected', props.data.get('id')], new Set()) : undefined,
        selectedLinks: props.data ?
          state.getIn(['links', 'data', 'links', 'selected',
            props.data.get('id')], new Set()) : undefined,
        product: state.getIn(['references', 'complex', 'product'], new List())
          .find(r => r.get('id') == props.elem.get('product')),
      };
    }
    return {
      product: state.getIn(['references', 'complex', 'product'], new List())
        .find(r => r.get('id') == props.elem.get('product')),
      list: state.getIn(['data', 'deals', 'list', props.dealType], new List()),
    };
  })(CompositeProductElement);
